<template>
  <div>
    <!-- <h6 class="mb-20">项目修改记录</h6> -->
    <a-form layout="inline" class="mb-20">
      <a-form-item label="修改类型">
        <a-select
          style="width: 120px"
          v-model="dataForm.log_type"
          placeholder="全部类型"
          allowClear
        >
          <a-select-option :value="1"> 查询 </a-select-option>
          <a-select-option :value="2"> 新增 </a-select-option>
          <a-select-option :value="3"> 修改 </a-select-option>
          <a-select-option :value="4"> 删除 </a-select-option>
          <a-select-option :value="5"> 交易 </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="记录内容">
        <a-input
        v-model="dataForm.log_content"
        placeholder="操作记录内容搜索"
      />
      </a-form-item>
      <a-form-item>
        <a-button @click="getDataList">查询</a-button>
      </a-form-item>
    </a-form>
    <a-timeline>
      <a-timeline-item
        v-for="v in dataList"
        :key="v.tripprojectlog_id"
        :color="
          v.log_type == 1
            ? 'gray'
            : v.log_type == 2
            ? 'green'
            : v.log_type == 3
            ? 'blue'
            : 'red'
        "
        >{{ v.log_content }}
        <p>{{ v.user.real_name }} {{ v.log_createtime }}</p>
      </a-timeline-item>
    </a-timeline>
    <a-empty v-if="dataList.length == 0" />
    <a-pagination
      size="small"
      class="mr-20 float-right"
      :current="page"
      :total="total"
      :show-total="(total) => `共 ${total} 条数据`"
      @showSizeChange="showSizeChange"
      @change="pageCurrentChangeHandle"
    />
  </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
export default {
  mixins: [viewModule],
  props: ["trip_id"],
  data() {
    return {
      dataForm: {
        trip_id: this.trip_id,
        log_type: 2,
        log_content: "",
      },
      mixinViewModuleOptions: {
        getDataListURL: "/admin/tripprojectlog/page",
      },
    };
  },
};
</script>

<style>
</style>